<script setup>
import { useAttrs, computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
const isDarkMode = ref(false);

const DEFAULT_DARK_LOGO = '/brand-assets/logo_thumbnail.svg';
const DEFAULT_LIGHT_LOGO = '/brand-assets/logo_thumb_black.svg';

let themeObserver;

const updateTheme = () => {
  isDarkMode.value = document.body.classList.contains('dark');
};

onMounted(() => {
  updateTheme();
  themeObserver = new MutationObserver(updateTheme);
  themeObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

onBeforeUnmount(() => {
  themeObserver?.disconnect();
});

const resolvedLogoSrc = computed(() => {
  const configuredLogo = globalConfig.value?.logoThumbnail;
  if (!configuredLogo) return '';

  if (configuredLogo === DEFAULT_DARK_LOGO) {
    return isDarkMode.value ? DEFAULT_DARK_LOGO : DEFAULT_LIGHT_LOGO;
  }

  return configuredLogo;
});
</script>

<template>
  <img
    v-if="resolvedLogoSrc"
    v-bind="attrs"
    :src="resolvedLogoSrc"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#woot-logo-clip-2342424e23u32098)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        :fill="isDarkMode ? '#2781F6' : '#000000'"
      />
      <path
        d="M11.4172 11.4172H7.70831C5.66383 11.4172 4 9.75328 4 7.70828C4 5.66394 5.66383 4 7.70835 4C9.75339 4 11.4172 5.66394 11.4172 7.70828V11.4172Z"
        fill="white"
        stroke="white"
        stroke-width="0.1875"
      />
    </g>
    <defs>
      <clipPath id="woot-logo-clip-2342424e23u32098">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
